import { pxToRem } from "src/styles/styleUtils";
import styled from "styled-components";
import AdUnit from ".";

const AdArea = styled.div`
  max-width: ${pxToRem(300)};
  min-height: ${pxToRem(250)};
  margin: 0 auto ${pxToRem(25)};
  background-color: ${({ theme }) => theme.grey_400};
`;

function PicksCompleteAd() {
  return (
    <AdArea>
      <AdUnit id="ad_interstitial_01" />
    </AdArea>
  );
}

export default PicksCompleteAd;
